import Basic from "./basic/basic";
import Advanced from "./advanced/advanced";
import ImagesCarousel from "./images-carousel";
import TextHeavyCarousel from "./text-heavy-carousel";
import Basic4 from "./basic-4/basic-4";
import Basic5 from "./basic-5/basic-5";
import Basic6 from "./basic-6/basic-6";
import Basic7 from "./basic-7/basic-7";
import Basic10 from "./basic-10/basic-10";
import Basic11 from "./basic-11/basic-11";
import Basic12 from "./basic-12/basic-12";
import Basic13 from "./basic-13/basic-13";
import Basic14 from "./basic-14/basic-14";
import Basic15 from "./basic-15/basic-15";
import Basic16 from "./basic-16/basic-16";
import Basic17 from "./basic-17/basic-17";
import Basic18 from "./basic-18/basic-18";
import Basic19 from "./basic-19/basic-19";
import Basic20 from "./basic-20/basic-20";
import Basic21 from "./basic-21/basic-21";
import Basic22 from "./basic-22/basic-22";
import Basic23 from "./basic-23/basic-23";

function GetTemplateByID(template_id) {
  let list = GetTemplateList();
  for (let i = 0; i < list.length; i++) {
    if (list[i].id === template_id) {
      return list[i];
    }
  }
  throw new Error("Template not found");
}

function GetTemplateList() {
  let allTemplates = [
    new TextHeavyCarousel(),
    new Basic(),
    new Advanced(),
    new ImagesCarousel(),
    new Basic4(),
    new Basic5(),
    new Basic6(),
    new Basic7(),
    new Basic10(),
    new Basic11(),
    new Basic12(),
    new Basic13(),
    new Basic14(),
    new Basic15(),
    new Basic16(),
    new Basic17(),
    new Basic18(),
    new Basic19(),
    new Basic20(),
    new Basic21(),
    new Basic22(),
    new Basic23(),
  ];
  // make sure each template has a unique id
  let idList = [];
  for (let i = 0; i < allTemplates.length; i++) {
    if (idList.includes(allTemplates[i].id)) {
      throw new Error("Template ID is not unique");
    }
    idList.push(allTemplates[i].id);
  }
  return allTemplates;
}

// to make sure all templates have a unique id
GetTemplateList();

function GetAdvancedTemplate() {
  return new TextHeavyCarousel();
}

function GetBasicTemplates() {
  return [
    new Basic23(),
    new Basic22(),
    new Basic21(),
    new Basic20(),
    new Basic19(),
    new Basic18(),
    new Basic17(),
    new Basic16(),
    new Basic15(),
    new Basic14(),
    new Basic13(),
    new Basic12(),
    new Basic11(),
    new Basic10(),
    new Basic7(),
    new Basic6(),
    new Basic5(),
    new Basic4(),
    new Basic(),
    new Advanced(),
    new ImagesCarousel(),
  ];
}

export {
  GetTemplateList,
  GetAdvancedTemplate,
  GetBasicTemplates,
  GetTemplateByID,
};
